import { API_URL } from "../config/config";
import { getRequest } from "../utils/axiosUtils";
import buildQueryParams from "../utils/buildQueryParams";

export const fetchGoogleAnalyticsList = async ({ filter = {}}) => {
    try {
        const {  dateRange,page,limit,searchTerm,sortBy,sortOrder } = filter;
        const queryParams = buildQueryParams({dateRange,page,limit,searchTerm,sortBy,sortOrder});

        const res = await getRequest({
            url: `${API_URL}/admin/analytics/google-analytics/influencer_ads?${queryParams}`,
        });
        if(!res) return

        if (res.status >= 200 && res.status < 300 && res.data) {
            return res.data;
        } else {
            throw new Error(`Unexpected response code: ${res.status}`);
        }
    } catch (error) {
        throw new Error(error?.message || "Failed to fetch google analytics list");
    }
};